import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface ResGetAllDashBoard {
  success: true;
  message: string;
  result:
    {
      firstrow:
        {
          date: string;
          num_user: number;
          num_fb: number;
          userperday: number;
          percen: number;
          num_admin: number;
          num_teacher: number;
          num_psy: number;
          normal_user: number;
          prem_user: number;
        }      ,
      secondrow:
        {
          type: string;
          allrevenue: [
            {
              category: string;
              value: number;
            },
            {
              category: string;
              value: number;
            },
            {
              category: string;
              value: number;
            },
            {
              category: string;
              value: number;
            }
          ];
          allwait: [
            {
              category: string;
              value: number;
            },
            {
              category: string;
              value: number;
            },
            {
              category: string;
              value: number;
            },
            {
              category: string;
              value: number;
            }
          ];
        }
      ,
      the_rest:
        {
          courses_num: number;
          course_register: number;
          consult_num: number;
          consult_register: number;
          workshop_num: number;
          workshop_register: number;
          test_num: number;
          test_participant: number;
          research_num: number;
          research_participant: number;
          news_num: number;
          news_reader: number;
          article_num: number;
          article_reader: number;
        }
    }
}

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  token: string = null;
  accessLink: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getAllDashBoard(data){
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<ResGetAllDashBoard>(environment.URL + '/dashboard/getAllDashBoard', data, { headers: headers });
  }
}
